<template>
  <div class="app-container" style="width: 100%; padding: 0px">
    <!-- style="overflow: -moz-scrollbars-none; -ms-overflow-style: none" -->
    <!-- <div><SidebarNav v-show="this.idx == 3" /></div> -->
    <div class="banner">
      <!-- <Carousel /> -->
      <Banner />
      <div style="margin-top: 15px">
        <span class="title">电商工具推荐</span>
        <div class="soft_tj_div">
          <div class="soft_tj">
            <img :src="soft_img1" v-if="cainiaoShow" alt="Image" class="image-style" />
            <img :src="soft_img1_qnp" v-if="qnpShow" alt="Image" class="image-style" />
            <img :src="soft_img1_ruyi" v-if="ruyiShow" alt="Image" class="image-style" />
            <img :src="soft_img1_ty" v-if="tyShow" alt="Image" class="image-style" />
            <img :src="soft_img1_hj" v-if="hjShow" alt="Image" class="image-style" />
            <br />
            <div class="desc">
              <div>{{ softwareName }}</div>
              <div class="soft_desc">
                <div class="icon_cs">
                  <img :src="tkxd_ys1" style="margin-top: 3px" class="zzc_img" />
                </div>
                <div class="icon_desc_cs">
                  <span>支持淘宝，抖音，拼多多，快手，1688，小红书店铺</span>
                </div>
                <div class="icon_desc_cs">
                  <img :src="tb_image" style="margin-left: 0" class="soft_img_cs" />
                  <img :src="dy_image" class="soft_img_cs" />
                  <img :src="pdd_image" class="soft_img_cs" />
                  <img :src="ks_image" class="soft_img_cs" />
                  <img :src="baba_image" class="soft_img_cs" />
                  <img :src="xhs_image" class="soft_img_cs" />
                </div>
                <div class="icon_cs" style="margin-top: 4.5vh">
                  <img :src="tkxd_ys2" style="margin-top: 5px" class="zzc_img" />
                </div>
                <div class="icon_desc_cs">
                  <span>支持到1688，淘宝，淘特，拼多多平台采购</span>
                </div>
                <div class="icon_desc_cs">
                  <img :src="baba_image" style="margin-left: 0px" class="soft_img_cs" />
                  <img :src="tb_image" class="soft_img_cs" />
                  <img :src="tbtjb_image" class="soft_img_cs" />
                  <img :src="pdd_image" class="soft_img_cs" />
                </div>
              </div>
              <div style="text-align: center; margin-top: 1.5vh; margin-left: -15px">
                <el-button type="primary" class="btn_cs" @click="downloadSoft"
                  >下载客户端</el-button
                >
              </div>
            </div>
          </div>

          <div class="soft_tj">
            <img :src="soft_img2" alt="Image" class="image-style" />
            <br />
            <div class="desc">
              <div>中转仓</div>
              <div class="soft_desc">
                <div style="height: 1.6vh">
                  <div class="icon_cs">
                    <img :src="zzc_ys1" class="zzc_img" />
                  </div>
                  <div class="icon_desc_cs">
                    <span>发到仓库 重新拆包 打单发货</span>
                  </div>
                </div>
                <br />
                <div style="height: 1.6vh">
                  <div class="icon_cs">
                    <img :src="zzc_ys2" class="zzc_img" />
                  </div>
                  <div class="icon_desc_cs">
                    <span>再也不用担心无货源问题</span>
                  </div>
                </div>
              </div>
              <div style="text-align: center; margin-top: 1.5vh; margin-left: -15px">
                <el-button type="primary" class="btn_cs" @click="toZzc"
                  >前往查看</el-button
                >
              </div>
            </div>
          </div>

          <div class="soft_tj">
            <img :src="soft_img3" alt="Image" class="image-style" />
            <br />
            <div class="desc">
              <div>客服助手</div>
              <div class="soft_desc">
                <div style="height: 1.1vh">
                  <div class="icon_cs">
                    <img :src="kfrj_ys1" class="zzc_img" />
                  </div>
                  <div class="icon_desc_cs">
                    <span>淘宝干牛客服工具</span>
                  </div>
                </div>
                <br />
                <div style="height: 1.1vh">
                  <div class="icon_cs">
                    <img :src="kfrj_ys2" class="zzc_img" />
                  </div>
                  <div class="icon_desc_cs">
                    <span>支持超时自动回复</span>
                  </div>
                </div>
                <br />
                <div style="height: 1.1vh">
                  <div class="icon_cs">
                    <img :src="kfrj_ys3" class="zzc_img" />
                  </div>
                  <div class="icon_desc_cs">
                    <span>自定义关键词自动同复</span>
                  </div>
                </div>
                <br />
                <div style="height: 1.1vh">
                  <div class="icon_cs">
                    <img :src="kfrj_ys4" class="zzc_img" />
                  </div>
                  <div class="icon_desc_cs">
                    <span>物流信息推送</span>
                  </div>
                </div>
                <br />
                <div style="height: 1.1vh">
                  <div class="icon_cs">
                    <img :src="kfrj_ys5" class="zzc_img" />
                  </div>
                  <div class="icon_desc_cs">
                    <span>取件码和取件地址推送</span>
                  </div>
                </div>
                <br />
                <div style="height: 1.1vh">
                  <div class="icon_cs">
                    <img :src="kfrj_ys6" class="zzc_img" />
                  </div>
                  <div class="icon_desc_cs">
                    <span>支持发送文字，图片，视频，PDF文档格式</span>
                  </div>
                </div>
              </div>
              <div style="text-align: center; margin-top: 1.5vh; margin-left: -15px">
                <el-button type="primary" class="btn_cs" @click="downloadSoft"
                  >下载客户端</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 100px">
          <span class="title">软件核心优势</span><br /><br />
          <div class="image-gallery">
            <div
              v-for="(item, index) in hxys_images"
              :key="index"
              class="hxys_image-item"
            >
              <img :src="item.image" alt="Image" class="hxys_img" />
              <div class="desc_desc">
                <span style="font-size: 16px; font-weight: bold">{{ item.desc }}</span>
                <div style="margin-top: 10px; text-align: left; color: #7a7c7e">
                  <span>{{ item.desc_desc }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="foot">
          <div class="foot_kf">
            <span style="font-weight: bold; font-size: 18px; color: white">联系客服</span
            ><br />
            <div style="float: left">
              <img :src="lxkf_image" class="lxkf_img_cs" style="margin-left: 0px" />
            </div>
            <div style="color: white; margin-top: 3px">
              <!-- <span style="color: white; margin-left: 12px">客服工作时间:9:00-18:00</span> -->
              <span style="margin-left: 12px">联系电话：{{ contactPhone }}</span>
              <br /><span style="margin-left: 12px">工作时间：9:00-18:00</span>
            </div>
          </div>

          <!-- <svg-icon icon-class="wechat" /> -->
          <!-- <div>
            <div class="kfwx_image-gallery">
              <canvas ref="qrcodeCanvas"></canvas>
              <br />
              <div>
                <span style="color: white">客服微信</span>
              </div>
            </div>
          </div> -->
        </div>
        <br />
        <div class="foot1">
          ———— <span><a href="https://beian.miit.gov.cn/" target="_blank">{{ record_number }}</a></span> ————
        </div>
      </div>
    </div>
    <!-- 公告弹出框 -->
    <el-dialog
      :visible.sync="xtgg_dialogFormVisible"
      style="text-align: center; width: 100%; height: 120%; overflow-y: auto"
      title="2026-02-28 抖音同步单 上线通知"
    >
      <el-form
        style="
          width: 100%;
          height: 100%;
          text-align: left;
        "
      >
        <el-form-item>
          <div style="background-color: #f7f8fb; padding-left: 20px;padding-right: 20px; border-radius: 0.6em;">
            <span style="font-weight:bold;font-size:18px;color:red;">抖音同步单， 解析地址注意事项</span><br />
            <span>
              <img src="@/assets/dytbd.png" alt="Image" style="width: 100%" />
            </span>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import Carousel from "./Carousel.vue";
import TopMenu from "../topmenu/TopMenu.vue";
import Banner from "./Banner.vue";
import QRCode from "qrcode";
// import Vue from "vue";
// Vue.component("svg-icon", SvgIcon);
import SvgIcon from "@/components/SvgIcon/index.vue";

/* eslint-disable */
export default {
  name: "home",
  components: {
    Carousel,
    TopMenu,
    Banner,
    SvgIcon,
  },
  data() {
    return {
      idx: 1,
      // images: [
      //   { image: require("@/assets/banner1.jpg"), desc: "下载客户端" },
      //   { image: require("@/assets/banner2.jpg"), desc: "前往查看" },
      //   { image: require("@/assets/banner3.jpg"), desc: "下载客户端" },
      // ],

      soft_img1: require("@/assets/tkxd.jpg"),
      soft_img2: require("@/assets/zzc.jpg"),
      soft_img3: require("@/assets/tkkfzs.jpg"),
      soft_img1_qnp: require("@/assets/qnp_tg.jpg"),
      soft_img1_ruyi: require("@/assets/ruyi_tg.jpg"),
      soft_img1_ty: require("@/assets/ty_tg.jpg"),
      soft_img1_hj: require("@/assets/hj_tg.jpg"),

      wx_image: require("@/assets/syfb.png"),

      tb_image: require("@/assets/tb.png"),
      dy_image: require("@/assets/dy.png"),
      pdd_image: require("@/assets/pdd.png"),
      ks_image: require("@/assets/ks.png"),
      baba_image: require("@/assets/1688.png"),
      xhs_image: require("@/assets/xhs.png"),
      tbtjb_image: require("@/assets/tbtjb.png"),
      lxkf_image: require("@/assets/lxkf.png"),

      tkxd_ys1: require("@/assets/tkxd_ys1.png"),
      tkxd_ys2: require("@/assets/tkxd_ys2.png"),

      zzc_ys1: require("@/assets/zzc_ys1.png"),
      zzc_ys2: require("@/assets/zzc_ys2.png"),

      kfrj_ys1: require("@/assets/kfrj_ys1.png"),
      kfrj_ys2: require("@/assets/kfrj_ys2.png"),
      kfrj_ys3: require("@/assets/kfrj_ys3.png"),
      kfrj_ys4: require("@/assets/kfrj_ys4.png"),
      kfrj_ys5: require("@/assets/kfrj_ys5.png"),
      kfrj_ys6: require("@/assets/kfrj_ys6.png"),

      hxys_images: [
        {
          image: require("@/assets/ys1.jpg"),
          desc: "使用方便",
          desc_desc:
            "中转仓、礼品单、双物流发货等，提供多种发货方式和快递选择，目前支持全部主流快递，满足不同快递需求",
        },
        {
          image: require("@/assets/ys2.jpg"),
          desc: "简约智能",
          desc_desc:
            "中转仓提供实时的物流追踪系统，用户可以陆时了解包事的运输状态和预计到达时间",
        },
        {
          image: require("@/assets/ys3.jpg"),
          desc: "降本增效",
          desc_desc:
            "能够迅速接收和处理寄送包衷，快速出单，降低开店成本，减少物流售后问题",
        },
        {
          image: require("@/assets/ys4.jpg"),
          desc: "快速售后",
          desc_desc: "提供7*9h的专属客服服务，解答使用中遇到的问题和售后",
        },
      ],
      kfwx_images: [
        { image: require("@/assets/jyzn.png"), desc: "官方客服：兔宝" },
        { image: require("@/assets/jyzn.png"), desc: "官方客服：海鲸" },
      ],
      image1: require("@/assets/banner1.jpg"),
      noticeBarTop: 0,
      softwareName: "",
      downloadUrl: "",
      kfwx_ewm: "",
      record_number: "", // 冀ICP备2023002566号-1
      cainiaoShow: false,
      qnpShow: false,
      ruyiShow: false,
      tyShow: true,
      hjShow: false,
      view_url: "",
      contactPhone: "",
      xtgg_dialogFormVisible: false,
    }
  },
  async created() {
    await this.$root.getSystemInfo();
    window.addEventListener("scroll", this.handleScroll);
    this.softwareName = Cookies.get("view_software");
    if (this.softwareName == undefined || this.softwareName == 'undefined') {
      this.softwareName = ""
    }
    this.downloadUrl = Cookies.get("view_software_url");
    this.kfwx_ewm = Cookies.get("view_qrcode_url");
    this.view_url = Cookies.get("view_url");
    const mobile = Cookies.get("view_mobile");
    if (
      mobile != null &&
      mobile != "" &&
      mobile != undefined &&
      mobile != "null" &&
      mobile != "undefined"
    ) {
      this.contactPhone = mobile;
    }

    const sn = Cookies.get("view_site_name");
    if (sn == "菜鸟云仓") {
      this.tyShow = false;
      this.cainiaoShow = true;
    } else if (sn == "全能拍云仓") {
      this.tyShow = false;
      this.qnpShow = true;
    } else if (sn == "如意云仓") {
      this.tyShow = false;
      this.ruyiShow = true;
    } else if (sn == "火箭云仓") {
      this.tyShow = false;
      this.hjShow = true;
    } else {
      this.tyShow = true;
    }

    const rn = Cookies.get("view_record_number");
    if (rn != null && rn != "" && rn != undefined && rn != "null" && rn != "undefined") {
      this.record_number = rn;
    }
    this.generateQRCode("ffrwaer3221");
    const isJustLogin = Cookies.get("justLogin");
    if (isJustLogin == 'true') {
      this.xtgg_dialogFormVisible = true;
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.noticeBarTop = window.scrollY || window.pageYOffset;
    },
  },
  methods: {
    downloadSoft() {
      if (this.downloadUrl.includes("http") || this.downloadUrl.includes("https")) {
        window.open(this.downloadUrl, "_blank");
      } else {
        window.open("//" + this.downloadUrl, "_blank");
      }
    },
    toZzc() {
      this.$router.push({ path: "/zzc" });
    },
    generateQRCode(url) {
      const options = {
        width: 80, // 控制二维码的宽度（像素）
        // height: 100 // 可以同时设置高度，如果你希望二维码是一个正方形，只需要设置宽度即可
        margin: 1,
        color: {
          dark: "#505050", // 灰色
          light: "#ffffff", // 白色（背景）
        },
      };
      QRCode.toCanvas(this.$refs.qrcodeCanvas, url, options, (error) => {
        if (error) {
          console.error(error);
        }
      });
    },
  },
};
</script>

<style scoped>
.banner {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  margin-left: 0;
  background-color: #f6f8fa;
  /* float: left; */
}
.title {
  font-size: 24px;
  color: black;
}
.soft_tj {
  width: 18vw;
  height: 53vh;
  border: rgb(212, 212, 212) solid 1px;
  border-radius: 1em;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}
.imgdiv {
  width: 18vw;
  height: 18vh;
  margin-top: 10px;
  /* margin-left: 10px; */
  border: rgb(224, 242, 255) solid 1px;
  background-color: rgb(224, 242, 255);
  border-radius: 1em;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
}
.soft_tj_div {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 70vw;
  height: 48vh;
  margin-left: 15vw;
  padding-top: 15px;
}
.image-gallery {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 70vw;
  margin-left: 15vw;
  padding-top: 5px;
}
.image-item {
  margin: 5px;
}
.image-style {
  width: 17.9vw;
  height: 18vh;
  border-top-left-radius: 1em;
  border-top-right-radius: 1em;
}
.desc {
  text-align: left;
  font-size: 18px;
  cursor: pointer;
  padding-left: 15px;
  margin-top: 6px;
  font-weight: bold;
  /* height: 61vh; */
}
.hxys_image-item {
  width: 15vw;
  margin: 5px;
}
.hxys_img {
  width: 14vw;
  /* height: 110px; */
  border-radius: 0.8em;
}
.desc_desc {
  text-align: center;
  padding: 12px 0;
}
.foot {
  width: 100%;
  margin-top: 60px;
  margin-bottom: -20px;
  background-color: #333333;
  height: 120px;
  text-align: left;
}
.foot_kf {
  margin-left: 18vw;
  padding-top: 35px;
  width: 20vw;
  height: 70px;
}

.kfwx_image-gallery {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 16vw;
  margin-left: 72vw;
  margin-top: -56px;
  font-size: 14px;
  width: 100px;
  height: 100px;
}
.kfwx_image-item {
  margin: 5px;
}
.kfwx_img {
  width: 80px;
  height: 80px;
}
.soft_desc {
  margin-top: 6px;
  font-weight: 500;
  font-size: 14px;
  color: #454545;
  margin-right: 0.8vw;
  height: 19vh;
}
.icon_cs {
  width: 1.3vw;
  float: left;
}
.icon_desc_cs {
  width: 14vw;
  float: right;
}
.soft_img_cs {
  height: 1.5vw;
  width: 1.5vw;
  margin: 0.6vh 0.3vw 0.8vh 0.3vw;
  /* margin-top: 1vh; */
}
.btn_cs {
  font-size: 13px;
  background-color: #0850fc;
  color: white;
  height: 38px;
  border-radius: 0.5em;
  width: 8vw;
}
.zzc_img {
  height: 25px;
  width: 27px;
  margin-top: -3px;
}
.foot1 {
  height: 30px;
  background-color: #222222;
  margin-top: -1px;
  color: white;
  text-align: center;
  padding-top: 5px;
}
.foot1 a { 
  color: white;
}
.wx_img {
  height: 60px;
  width: 60px;
}
.lxkf_img_cs {
  height: 2vw;
  width: 2vw;
  margin-top: 5px;
}
.svg-icon {
  display: block;
  margin: -4px auto !important;
  float: none !important;
}

/* 针对Chrome, Safari和Opera */
::-webkit-scrollbar {
  display: none;
}
</style>
<style>
.el-dialog__title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/index/home.vue